var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5870_8586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 8.75H14.25V13.75H9.25V16.25H14.25V21.25H16.75V16.25H21.75V13.75H16.75V8.75ZM15.5 2.5C8.6 2.5 3 8.1 3 15C3 21.9 8.6 27.5 15.5 27.5C22.4 27.5 28 21.9 28 15C28 8.1 22.4 2.5 15.5 2.5ZM15.5 25C9.9875 25 5.5 20.5125 5.5 15C5.5 9.4875 9.9875 5 15.5 5C21.0125 5 25.5 9.4875 25.5 15C25.5 20.5125 21.0125 25 15.5 25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5870_8586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateButtonIcon);
export default __webpack_public_path__ + "static/media/create-button-icon.4d225097da1bbbee855ea1f433dd3a77.svg";
export { ForwardRef as ReactComponent };